import React from "react";
import {
  Heart,
  Instagram,
  Mail,
  Phone,
  MapPin,
  MessageSquareShare,
  MessageCircle,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { gtmPush, trackExternalLink } from "../utils/gtm";

function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center mb-4">
              <Heart className="h-8 w-8 text-purple-400 mr-2" />
              <span className="text-xl font-bold">Srilatha Rakesh</span>
            </div>
            <p className="text-gray-400 mb-6">
              Empowering individuals to unlock their potential and create
              meaningful change in their lives.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://instagram.com/SrilathaRakesh.lifecoach"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  trackExternalLink(
                    "social_click",
                    "instagram",
                    "https://instagram.com/SrilathaRakesh.lifecoach",
                    { destination_page: "instagram_profile" },
                  )
                }
                className="text-gray-400 hover:text-purple-400 transition-colors"
              >
                <Instagram className="h-6 w-6" />
              </a>
              {/* <a
                href="https://youtube.com/@Srilatha Rakesh"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-purple-400 transition-colors"
              >
                <Youtube className="h-6 w-6" />
              </a> */}
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="#" className="hover:text-purple-400 transition-colors">
                  1-on-1 Coaching
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-purple-400 transition-colors">
                  Group Coaching
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-purple-400 transition-colors">
                  Online Workshops
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-purple-400 transition-colors">
                  Digital Support
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-purple-400 transition-colors">
                  Corporate Training
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          {/* <div>
            <h3 className="text-lg font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="#" className="hover:text-purple-400 transition-colors">
                  Blog
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-purple-400 transition-colors">
                  Videos
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-purple-400 transition-colors">
                  Podcast
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-purple-400 transition-colors">
                  Free Resources
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-purple-400 transition-colors">
                  Success Stories
                </a>
              </li>
            </ul>
          </div> */}

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-3 text-gray-400">
              <div className="flex items-center">
                <Phone className="h-5 w-5 mr-3" />
                <a
                  href="tel:+918977895528"
                  onClick={() =>
                    gtmPush("phone_click", {
                      phone_number: "+918977895528",
                      click_location: "footer",
                    })
                  }
                  className="hover:text-purple-400 transition-colors"
                >
                  +91 8977895528
                </a>
              </div>
              <div className="flex items-center">
                <MessageCircle className="h-5 w-5 mr-3" />
                <a
                  href="https://wa.me/918977895528"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() =>
                    trackExternalLink(
                      "whatsapp_click",
                      "whatsapp",
                      "https://wa.me/918977895528",
                      { phone_number: "+918977895528" },
                    )
                  }
                  className="hover:text-purple-400 transition-colors"
                >
                  WhatsApp
                </a>
              </div>
              <div className="flex items-center">
                <Mail className="h-5 w-5 mr-3" />
                <span>info.srilatharakesh@gmail.com</span>
              </div>
              <div className="flex items-start">
                <MapPin className="h-5 w-5 mr-3 mt-1" />
                <span>
                  Hyderabad
                  <br />
                  Telangana, India
                </span>
              </div>
              <div
                className="flex items-center cursor-pointer hover:text-purple-400 transition-colors"
                onClick={() => {
                  gtmPush("feedback_link_click", {
                    link_name: "employee_feedback",
                    destination: "/employee-feedbackform",
                  });
                  navigate("/employee-feedbackform");
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                <MessageSquareShare className="h-5 w-5 mr-3" /> Feedback
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2025 Srilatha Rakesh. All rights reserved.
            </p>
            {/* <div className="flex space-x-6 mt-4 md:mt-0">
              <a
                href="#"
                className="text-gray-400 hover:text-purple-400 text-sm transition-colors"
              >
                Privacy Policy
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-purple-400 text-sm transition-colors"
              >
                Terms of Service
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-purple-400 text-sm transition-colors"
              >
                Cookie Policy
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
